<template>
  <el-dialog
    v-if="dialogSwitch"
    :visible.sync="dialogSwitch"
    :close-on-click-modal="false"
    class="dialogBox"
    width="550px"
    @close="dialogSwitch = false"
    :modal-append-to-body="false">
    <div class="title" slot="title">冻结原因</div>
    <div class="messageContent">
      <div class="dataBox">
        <div class="info">
          <p>链接名称：{{linkDetail.linkName}}</p>
          <p>链接地址：{{linkDetail.linkUrl}}</p>
        </div>
        <div class="reason">
          {{linkDetail.reason}}
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogSwitch:false,
      id:"",
      linkDetail:{

      }
    };
  },
  created(){
  
  },
  methods: {
    show(id) {
      this.id=id;
      this.dialogSwitch = true;
      this.queryFreezeReason()
    },
    //获取应用信息
    queryFreezeReason(){
      this.$apis.consoleSever.queryFreezeReason({
        id:this.id,
      }).then(res=>{
        if (res.code == 0) {
          this.linkDetail=res.data;

        }
      })
    },
  },
};
</script>

<style scoped lang="scss">
.dialogBox {
  /deep/ .el-dialog {
    border-radius: 10px;
    .el-dialog__body {
      padding: 10px 32px 20px;
    }
  }
  .title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }
  
  .closeIcon {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 30px;
    height: 30px;
  }
  .messageTitle {
    position: relative;
    margin-bottom: 40px;
    font-size: 20px;
    color: rgba(18, 18, 18, 1);
    text-align: center;
  }
  .messageContent {
    font-size: 16px;
    .dataBox{
      .info{
        padding: 15px;
        background: rgba(250, 250, 250, 1);
        line-height: 25px;
        margin-bottom: 15px;
        color: #aaa;
      }
      .reason {
        padding: 0 15px;
      }
    }
  }
}

</style>
